import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { loadIntercom, updateIntercom } from '@/helpers/intercom'
import { isNil } from '@/helpers/helpers'

declare global {
  interface Window {
    Intercom?: any
  }
}

export const IntercomProvider = ({ children }): React.ReactElement => {
  const router = useRouter()

  if (typeof window !== 'undefined' && isNil(window?.Intercom)) {
    loadIntercom()
  }

  useEffect(() => {
    const handleRouteChange = (): void => {
      if (typeof window !== 'undefined') {
        updateIntercom()
      }
    }
    router.events.on('routeChangeStart', handleRouteChange)
    // If the component is unmounted, unsubscribe
    // from the event with the `off` method:
    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [router.events])

  return children
}
